/**
 * Rafraîchit la barre de progression #CartDrawer-progress
 * en re-fetchant la section cart-drawer depuis Shopify.
 */
function ldsRefreshProgressBar() {
    fetch(window.Shopify.routes.root + '?section_id=cart-drawer')
        .then(function (response) { return response.text(); })
        .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var newProgress = doc.getElementById('CartDrawer-progress');
            var currentProgress = document.getElementById('CartDrawer-progress');
            if (newProgress && currentProgress) {
                currentProgress.outerHTML = newProgress.outerHTML;
            }
        });
}

/**
 * Intercepte les appels fetch vers les endpoints du panier Shopify
 * pour déclencher le rafraîchissement de la barre de progression.
 */
(function () {
    var originalFetch = window.fetch;
    window.fetch = function () {
        var args = arguments;
        var url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
        var result = originalFetch.apply(this, args);

        if (/\/cart\/(add|change|update)(\.js)?/.test(url)) {
            result.then(function (response) {
                if (response.ok) {
                    ldsRefreshProgressBar();
                }
                return response;
            });
        }

        return result;
    };
})();